import axios from 'axios';
import { auth } from './firebase';
import { empresaActual } from './empresa';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: agregar Bearer token a todas las requests
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      console.error('Error getting Firebase token:', err);
    }
  }
  // DA-16: con qué empresa se trabaja. El servidor la valida en cada pedido.
  const empresa = empresaActual();
  if (empresa) config.headers['X-Empresa'] = empresa;
  return config;
});

// Interceptor: si recibimos 401, redirigir a login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      // Con reemplazo: /login manda al hub, y «atrás» desde el hub no debe
      // volver a esta página para rebotar otra vez (DA-9, 2026-10-30).
      window.location.replace('/login');
    }
    // Un 422 de validación llega como lista de errores: las pantallas
    // muestran `detail` como texto, así que se convierte en el motivo legible
    // (sin el «Value error,» que antepone Pydantic).
    const d = error.response?.data?.detail;
    if (Array.isArray(d)) {
      error.response.data.detail = d.map((x) => String(x?.msg || '').replace(/^Value error, /, '')).join(' · ');
    }
    return Promise.reject(error);
  }
);

export default api;
